<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="csaDowntimeForm">
        <div class="my-section-box__headline">
        {{ 'common.value_calculator_csa_title' | cxTranslate }}</div>
        <div class="my-section-box csaDowntime" id="csaDowntime">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="roadsideCallRate">
                {{ 'common.value_calculator_roadsideCallRate' | cxTranslate }}*</label>
                <div class="row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="roadsideCallRate" />
                    @if (form.roadsideCallRate.invalid && (form.roadsideCallRate.dirty || form.roadsideCallRate.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_roadsideCallRate_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_usdOcc_text' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip(
                                'common.value_calculator_roadsideCallRate',
                                 'common.value_calculator_roadsideCallRate_toolTip')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="endasure-csa-downtime Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="annualRoadsideCallsToActuators">
                {{ 'common.value_calculator_annualRoadsideCallsToActuators' | cxTranslate }}</label>
                <div class="row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="annualRoadsideCallsToActuators" />
                    @if (form.annualRoadsideCallsToActuators.invalid && (form.annualRoadsideCallsToActuators.dirty || form.annualRoadsideCallsToActuators.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_annualRoadsideCallsToActuators_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_calls_text' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="roadsideCallRateCsaViolation">
                {{ 'common.value_calculator_roadsideCallRateCsaViolation' | cxTranslate }}*</label>
                <div class="row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="roadsideCallRateCsaViolation" />
                    @if (form.roadsideCallRateCsaViolation.invalid && (form.roadsideCallRateCsaViolation.dirty || form.roadsideCallRateCsaViolation.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_roadsideCallRateCsaViolation_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_usdOcc_text' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip(
                            'common.value_calculator_roadsideCallRateCsaViolation',
                             'common.value_calculator_roadsideCallRateCsaViolation_toolTip')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="endasure-csa-downtime Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="annualOutOfServiceCsaViolations">
                {{ 'common.value_calculator_annualOutOfServiceCsaViolations' | cxTranslate }}</label>
                <div class="row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="annualOutOfServiceCsaViolations" />
                    @if (form.annualOutOfServiceCsaViolations.invalid && (form.annualOutOfServiceCsaViolations.dirty || form.annualOutOfServiceCsaViolations.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_annualOutOfServiceCsaViolations_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_violations_text' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="fleetDowntimeRate">
                {{ 'common.value_calculator_fleetDowntimeRate' | cxTranslate }}</label>
                <div class="row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="fleetDowntimeRate" />
                    @if (form.fleetDowntimeRate.invalid && (form.fleetDowntimeRate.dirty || form.fleetDowntimeRate.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_cal_fleetDowntimeRate_valMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_usdDay_text' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>